import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Chips, SectionLabel } from "./PlanShared";
import { AMBIANCES, HEBERGEMENTS, RYTHMES, GASTRO, TRANSPORTS } from "./planConstants";

export function Step2Desires({ data, set, tog, onNext, onPrev }) {
  return (
    <div className="animate-fade-in-up mt-8 space-y-6">
      <div>
        <p className="section-label">Étape 2</p>
        <h2 className="text-4xl" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}>
          Vos envies
        </h2>
        <p className="text-sm text-[#5C554E] mt-1 italic" style={{ fontFamily: "'Lora', Georgia, serif" }}>
          Sélectionnez ce qui vous attire — votre conseiller en tiendra compte.
        </p>
      </div>

      <div className="card-surface space-y-1">
        <SectionLabel>Ambiances recherchées</SectionLabel>
        <Chips options={AMBIANCES} selected={data.ambiances} onToggle={(v) => tog("ambiances", v)} />
        <SectionLabel>Hébergement préféré</SectionLabel>
        <Chips options={HEBERGEMENTS} selected={data.hebergement} onToggle={(v) => tog("hebergement", v)} />
        <SectionLabel>Rythme de voyage</SectionLabel>
        <Chips options={RYTHMES} selected={[data.rythme]} onToggle={(v) => set("rythme", v)} />
        <SectionLabel>Gastronomie</SectionLabel>
        <Chips options={GASTRO} selected={data.gastronomie} onToggle={(v) => tog("gastronomie", v)} />
        <SectionLabel>Transport sur place</SectionLabel>
        <Chips options={TRANSPORTS} selected={data.transport_sur_place} onToggle={(v) => tog("transport_sur_place", v)} />
      </div>

      <div className="flex gap-3">
        <button onClick={onPrev} className="btn-secondary flex items-center gap-2" data-testid="step2-prev-btn">
          <ChevronLeft size={15} strokeWidth={2} /> Retour
        </button>
        <button onClick={onNext} className="btn-primary flex-1 flex items-center justify-center gap-2" data-testid="step2-next-btn">
          Continuer <ChevronRight size={15} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
}
